import { createElementAs, useMediaStore } from '@udecode/plate';

export const useMediaEmbedVideo = ({
  ...props
}) => {
  const { url } = useMediaStore().get.urlData();

  return {
    title: 'embed',
    frameBorder: '0',
    allowFullScreen: true,
    src: url,
    ...props,
  };
};

export const MediaEmbedVideo = (props) => {
  const htmlProps = useMediaEmbedVideo(props);

  return createElementAs('iframe', htmlProps);
};
